import { BaseComponentProps } from '@/components/BaseComponentProps';
import { cn } from '@agnes/ui';

export interface BadgeIncidenciaProps extends BaseComponentProps {
  nome: 'CP' | 'IRRF' | 'FGTS' | 'CPRP' | 'PIS';
  codigo?: string;
}

export function BadgeRubricaIncidencia({
  nome,
  codigo,
  className,
  dataQa,
  ...props
}: BadgeIncidenciaProps) {
  return (
    <span
      data-qa={dataQa ? `${dataQa}-badge-incidencia` : undefined}
      className={cn(
        className,
        'flex flex-col items-center rounded-md bg-agnes-bg-muted px-2 py-1 text-xs',
      )}
      {...props}
    >
      <span className="text-agnes-text-muted">{nome}</span>
      <span className="font-semibold text-agnes-text">{codigo || '-'}</span>
    </span>
  );
}
